import { merge } from "lodash-es"
import type HttpClient from "../../tastyworks/http"
import {
  IRA_CONSTRAINTS_DESER,
  IraConstraints,
  type IraConstraintTransferMethods,
} from "../../tastyworks/ira-constraint"
import { recursiveDasherizeKeys, type Params } from "../../tastyworks/request"
import type { SingleResponse } from "../../tastyworks/response"

export interface DepositIraConstraintParams extends Params {
  transferMethod: IraConstraintTransferMethods
}
export class DepositIraConstraintService {
  constructor(private readonly accountNumberClient: HttpClient) {}
  readonly show = async (
    accountNumber: string,
    params: DepositIraConstraintParams
  ): Promise<SingleResponse<IraConstraints>> =>
    this.accountNumberClient.show(
      new IraConstraints(),
      IRA_CONSTRAINTS_DESER.update,
      "deposit-ira-constraints",
      merge({ accountNumber }, recursiveDasherizeKeys(params))
    )
}
